import { FrontendPortal } from "@vega-api/generated/types/frontendPortal";
import {
  isGPCoInvestPortal,
  isGPPortal,
  isLPCoInvestPortal,
  isLPPortal,
} from "@vega-core/utils/global";

/**
 * Determines current portal type based on environment variables
 * Used when portal source is not available as a prop
 */
export const getCurrentPortalType = (): FrontendPortal => {
  if (isGPCoInvestPortal) {
    return FrontendPortal.COINVEST_WORKBENCH_PORTAL;
  } else if (isLPCoInvestPortal) {
    return FrontendPortal.COINVEST_INVESTOR_PORTAL;
  } else if (isGPPortal) {
    return FrontendPortal.GP_PORTAL;
  } else if (isLPPortal) {
    return FrontendPortal.LP_PORTAL;
  } else {
    // Default fallback
    return FrontendPortal.LP_PORTAL;
  }
};
